module.exports = __webpack_public_path__ + "static/media/professional.fe5c2d0b.webp";